'use client'

import { forwardRef, useImperativeHandle, useState } from 'react'
import styles from './ua.module.scss'
import Button from '../button/Button'
import Icon from '../icon/Icon'

const CollapsedText = forwardRef((props, ref) => {
  
  const [expanded,setExpanded] = useState(false)

  const toggle = () => {
    setExpanded(!expanded)
  }
  
  useImperativeHandle(ref, () => ({
    toggle
  }))
  
  return <>
    <section className={ styles.cont + ' ' + (props.fullCollapsed ? styles.full : '') + ' ' + (expanded ? styles.exp : '' ) }>
      { props.children }
    </section>
    { props.expandLabel &&
    <section className={ styles.expander } aria-hidden="true">
      <Button theme="transparent" className={ expanded ? styles.btn : '' } onPress={e => toggle()} label={ expanded ? props.collapseLabel : props.expandLabel }>
        <span>{ expanded ? props.collapseLabel : props.expandLabel }</span> <Icon {...props} name="chevron-down"></Icon>
      </Button>
    </section>
    }
  </>
  
})

CollapsedText.displayName = 'CollapsedText';
export default CollapsedText